module.exports = __webpack_public_path__ + "img/logo-usdt.00e5f4b4.png";